import { Row, Col, Table, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import AdminLinksComponent from "../../../components/admin/AdminLinksComponent";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { TableHeader, Pagination, Search } from "../../../components/DataTable";

const NoteBookComponent = ({ fetchNoteBooks, deleteNoteBook }) => {
  const [noteBooks, setNoteBooks] = useState([]);
  const [noteBookDeleted, setNoteBookDeleted] = useState(false);
  const { userInfo } = useSelector((state) => state.userRegisterLogin);
  const [salesSignedCompanies, setSalesSignedCompanies] = useState([])
  const [filterValue, setFilterValue] = useState("ALL REPRESENTATIVES");
  const [showFilteredRepresentatives, setShowFilteredRepresentatives] = useState(false)
  const [search, setSearch] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 40;

  const deleteHandler = async (noteBookId) => {
    if (window.confirm("Are You Sure")) {
      const data = await deleteNoteBook(noteBookId);
      if (data.message === "Note Book Deleted") {
        setNoteBookDeleted(!noteBookDeleted);
        window.location.reload(false);
      }
    }
  };

  useEffect(() => {
    const abctrl = new AbortController();
    fetchNoteBooks(abctrl)
      .then((res) => setNoteBooks(res))
      .catch((er) => {
        if (er.code === "ERR_CANCELED") {
          // console.log("Fetch request was cancelled");
        } else if (er.response) {
          console.log(
            er.response.data.message
              ? er.response.data.message
              : er.response.data
          );
        } else {
          console.log(er);
        }
      });
    return () => abctrl.abort();
  }, [noteBookDeleted]);

  useEffect(() => {
    if (!userInfo?.isExtSales) {
      setTotalItems(noteBooks.length)
      return;
    }
    // 1. Get all companies signed by this extSales user
    const signedCompanies = noteBooks
      .filter(book => book.signedBy === userInfo.email)
    setSalesSignedCompanies(signedCompanies)
    setTotalItems(signedCompanies.length)
  }, [noteBooks])

  //FILTERS AND SEARCH
  useEffect(() => {
    let filteredUsers = userInfo.isExtSales === true ? salesSignedCompanies : noteBooks
    if (filterValue !== "ALL REPRESENTATIVES") {
      filteredUsers = filteredUsers.filter(
        (user) => user.signedBy?.split("@")[0].toUpperCase() === filterValue?.toUpperCase()
      );
    }

    if (search) {
      filteredUsers = filteredUsers.filter(
        (user) =>
          user.companyName?.toUpperCase().includes(search.toUpperCase()) ||
          user.contactEmail?.toUpperCase().includes(search.toUpperCase()) ||
          user.contactPerson?.toUpperCase().includes(search.toUpperCase()) ||
          user.notes?.toUpperCase().includes(search.toUpperCase())
      );
    }
    setShowFilteredRepresentatives(filteredUsers);
    setTotalItems(filteredUsers.length)
  }, [salesSignedCompanies, noteBooks, userInfo, search, filterValue])

  return (
    <Row className="content-container m-5">
      <Col md={2}>
        <AdminLinksComponent />
      </Col>
      <Col md={10}>
        <h1>
          Sales Notes{" "}
          <LinkContainer to="/admin/create-new-noteBook">
            <Button
              variant="success"
              className="m-0 me-4 ms-4 p-0 pe-1 ps-1"
              size="lg"
            >
              New
            </Button>
          </LinkContainer>
        </h1>
        <div className="row mb-1">
          <div className="col-md-5">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
          <div className="col-md-3">

          </div>
          {/* filter and search */}
          <div className="col-md-4 d-flex justify-content-between">
            {
              !userInfo?.isExtSales ? (
                <select
                  value={filterValue}
                  onChange={(e) => setFilterValue(e.target.value)}
                  className="form-select me-3"
                >
                  <option value="ALL REPRESENTATIVES">ALL REPRESENTATIVES</option>
                  {[...new Set(noteBooks?.map(book => book.signedBy.split("@")[0].charAt(0).toUpperCase() + book.signedBy.split("@")[0].slice(1)).filter(Boolean))]
                    .sort()
                    .map(rep => (
                      <option key={rep} value={rep}>
                        {rep}
                      </option>
                    ))}
                </select>
              ) : ("")
            }

            <Search
              onSearch={(value) => {
                setSearch(value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>

        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>#</th>
              <th width="15%">Company Name</th>
              <th width="15%">Contact Person</th>
              <th width="15%">Contact Email</th>
              <th width="10%">Date</th>
              {!userInfo?.isExtSales ? (
                <th width="10%">Rep. Name</th>
              ) : ("")}
              <th width="25%">Notes</th>
              <th width="10%">Response</th>
              <th width="10%">Edit/Delete</th>
            </tr>
          </thead>
          <tbody>
            {((filterValue !== "ALL REPRESENTATIVES" || search !== "")
              ? showFilteredRepresentatives
              : userInfo?.isExtSales === true ? salesSignedCompanies : noteBooks).map((book, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{book.companyName}</td>
                  <td>{book.contactPerson}</td>
                  <td>{book.contactEmail}</td>
                  <td>{book.createdDate}</td>
                  {!userInfo?.isExtSales ? (
                    <th width="10%"> {book.signedBy
                      ? book.signedBy.split("@")[0].charAt(0).toUpperCase() + book.signedBy.split("@")[0].slice(1)
                      : ""}</th>
                  ) : ("")}
                  <div style={{ minHeight: '70px', maxHeight: '180px', overflowY: 'auto', whiteSpace: 'pre-wrap' }}>
                    {book.notes}
                  </div>
                  <td>{book.onboard}</td>
                  <td>
                    <LinkContainer to={`/admin/edit-noteBook/${book._id}`}>
                      <Button className="btn-sm btn-light">
                        <i className="bi bi-pencil-square"></i>
                      </Button>
                    </LinkContainer>
                    {" / "}
                    <Button
                      variant="danger"
                      className="btn-sm btn-light"
                      onClick={() => deleteHandler(book._id)}
                      disabled={userInfo?.isExtSales}
                    >
                      <i className="bi bi-x-circle"></i>
                    </Button>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Col>
    </Row>
  );
};

export default NoteBookComponent;
